import _slicedToArray from "C:/Users/mmira/Desktop/gatsby_sites/gatsby-koms/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useContext, useMemo, useRef, useReducer } from 'react';
import { useIsomorphicLayoutEffect } from './utils';
import { createDeepProxy, isDeepChanged } from './deepProxy';
import { createUseUpdate } from './createUseUpdate';
export var createUseTrackedState = function createUseTrackedState(context) {
  return function () {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _useReducer = useReducer(function (c) {
      return c + 1;
    }, 0),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        forceUpdate = _useReducer2[1];

    var _useContext = useContext(context),
        state = _useContext.state,
        subscribe = _useContext.subscribe;

    var affected = new WeakMap();
    var lastTracked = useRef(null);
    useIsomorphicLayoutEffect(function () {
      lastTracked.current = {
        state: state,
        affected: affected,
        cache: new WeakMap(),

        /* eslint-disable no-nested-ternary, indent */
        assumeChangedIfNotAffected: opts.unstable_forceUpdateForStateChange ? true : opts.unstable_ignoreIntermediateObjectUsage ? false :
        /* default */
        null
        /* eslint-enable no-nested-ternary, indent */

      };
    });
    useIsomorphicLayoutEffect(function () {
      var callback = function callback(nextState) {
        if (lastTracked.current.state === nextState || !isDeepChanged(lastTracked.current.state, nextState, lastTracked.current.affected, lastTracked.current.cache, lastTracked.current.assumeChangedIfNotAffected)) {
          // not changed
          return;
        }

        forceUpdate();
      };

      var unsubscribe = subscribe(callback);
      return unsubscribe;
    }, [subscribe]);
    var proxyCache = useRef(new WeakMap()); // per-hook proxyCache

    return createDeepProxy(state, affected, proxyCache.current);
  };
};
export var createUseTracked = function createUseTracked(context) {
  var useTrackedState = createUseTrackedState(context);
  var useUpdate = createUseUpdate(context);
  return function (opts) {
    var state = useTrackedState(opts);
    var update = useUpdate();
    return useMemo(function () {
      return [state, update];
    }, [state, update]);
  };
};